import * as React from "react";
import Dropdown from "../../Dropdown/Dropdown";
import { GET_ALL_PRODUCT_TYPES, GET_MARKETS_BY_PRODUCT_TYPE, GET_TERRITORIES_V2_BY_MARKET } from "../../../consts/queries";
import { executeQuery } from "../../../requests/executeQuery";
import { executeBackendQuery } from "../../../requests/executeBackendQuery";
import { ASSIGNED_TERRITORIES } from "../../../consts/tables";
import { useEffect, useState, useMemo } from "react";
import { manageData } from "../../../requests/CRUD";

const TeamMemberTerritoriesInfo = ({state, setState, territories, territory, viewMode, index}) => {
    const [productTypeOptions, setProductTypeOptions] = useState([]);
    const [marketOptions, setMarketOptions] = useState([]);
    const [territoryOptions, setTerritoryOptions] = useState([]);

    const [marketOptionsCached, setMarketOptionsCached] = useState([]);
    const [territoryOptionsCached, setTerritoryOptionsCached] = useState([]);

    const territoryCityOptions = useMemo(() => {
        return territoryOptions.map(tc => ({
            code: String(tc.ARCIMEDES_ROW_ID),
            name: tc.NAME,
        }));
    }, [territoryOptions]);

    useEffect(() => {
        //We need to add the existing market as option because we dont have the list when we read , so the select stays empty because of that , so we add the added market as option
        if(territory.isExisting && marketOptions.length == 0){
            let arrayITem = [
                {
                    ARCIMEDES_ROW_ID: territory.MARKET_ID,
                    CODE: territory.MARKET_CODE,
                    NAME: territory.MARKET_NAME
                }

            ]
            setMarketOptions(arrayITem)
        }
    }, [territory])

    useEffect(() => {
        //We need to add the existing territory as option because we dont have the list when we read data, so the select stays empty because of that , so we add the added territory as option
        if(territory.isExisting && territoryOptions.length == 0){
            let arrayITem = [
                {
                    ARCIMEDES_ROW_ID: territory.TERRITORY_ID,
                    NAME: territory.NAME,
                }

            ]
            setTerritoryOptions(arrayITem)
        }
    }, [territory])

    useEffect(() => {
        // We fetch product type
        fetchProductTypes();
    }, []);
 
    useEffect(() => {
        // After a product type is set (selected OR loaded), fetch its markets.
        // Use the id we already hold rather than looking it up in productTypeOptions —
        // on load that list isn't populated yet, and the loaded id may not strict-equal
        // an option id, so a find() would miss and the markets would never load.
        if(territory.PRODUCT_TYPE_ID){
            fetchMarketsByProductType(territory.PRODUCT_TYPE_ID);
        }
    },[territory.PRODUCT_TYPE_ID]);

    useEffect(() => {
        // After a market is set, fetch its territories. Market alone determines the
        // product type in the data, so no product filter is needed here.
        if(territory.MARKET_ID){
            fetchTerritoresByMarket(territory.MARKET_ID);
        }
    },[territory.MARKET_ID]);

    //Reset all fields when product type changes
    const resetAllOnProductChange = () => {
        setMarketOptions([])
        setTerritoryOptions([])
        setState(prevState => {
            const territories = [...prevState.territories];
            const territory = { ...territories[index] };
            territory.MARKET_ID = "",
            territory.TERRITORY_ID = "";
            territories[index] = territory;

            return { territories };
        })
    }

    //Reset all territories when market change
    const resetTerritoriesOnMarketChange = () => {
        setTerritoryOptions([])
        setState(prevState => {
            const territories = [...prevState.territories];
            const territory = { ...territories[index] };
            territory.TERRITORY_ID = "";
            territories[index] = territory;

            return { territories };
        })
    }

    const fetchProductTypes = () => {
        //function to fetch product types
        const options = {
            "param": {},
        }
        Promise.all([executeBackendQuery({ queryName: GET_ALL_PRODUCT_TYPES, options, expireTime: 1000 }),          
        ]).then(res => {         
            setProductTypeOptions(res[0].data);
        });
    }

    const fetchMarketsByProductType = (productType, mode) => {
        // Activate the PRODUCT_TYPE_ID where-slot (CW1) + NAME order-slot (CO1). Without
        // filter.where the backend applies no WHERE and returns *all* markets.
        const options = {
            filter: { where: ['CW1'] },
            order: ['CO1'],
            param: { PRODUCT_TYPE_ID: productType },
        }
        Promise.all([executeBackendQuery({ queryName: GET_MARKETS_BY_PRODUCT_TYPE, options, expireTime: 1000 }),
        ]).then(res => {
            setMarketOptions(res[0].data);
            if(mode == "read"){
                setMarketOptionsCached(res[0].data)
            }
        });
    }

    const fetchTerritoresByMarket = (marketId, mode) => {
        // Activate the MARKET_ID where-slot (CW1) + NAME order-slot (CO1) so territories
        // are actually filtered by market (otherwise all territories come back).
        const options = {
            filter: { where: ['CW1'] },
            order: ['CO1'],
            param: { MARKET_ID: marketId },
        }
        Promise.all([executeBackendQuery({ queryName: GET_TERRITORIES_V2_BY_MARKET, options, expireTime: 1000 }),
        ]).then(res => {
            setTerritoryOptions(res[0].data);
            if(mode == "read"){
                setTerritoryOptionsCached(res[0].data)
            }
        });
    }
    const onTerritoryChange = (e, key, index) => {
        if(key == "PRODUCT_TYPE"){
            resetAllOnProductChange()
        }
          if(key == "MARKET"){
            resetTerritoriesOnMarketChange()
        }
        //On dropdown change we call this function to update state
        setState(prevState => {
            const territories = [...prevState.territories];
            const territory = { ...territories[index] };

            if (key === "PRODUCT_TYPE") {
            const found = productTypeOptions.find(
                el => el.CODE === e.TYPE
            );

            territory.PRODUCT_TYPE_ID = found
                ? found.ARCIMEDES_ROW_ID
                : "";
            } else if (key === "MARKET") {
                const found = marketOptions.find(
                    m => m.CODE === e.MARKET
                );
                territory.MARKET_ID = found
                    ? found.ARCIMEDES_ROW_ID
                    : "";
            } else {
                const found = territoryCityOptions.find(
                    m => m.code === e.TERRITORY
                );
                territory.TERRITORY_ID = found ? found.code : "";
            }

            territories[index] = territory;

            return { territories };
        });
    };

    const deleteTerritory = () => {
        // Remove from local state only. The actual DB soft-delete for existing rows
        // happens on Save (see assignTerritores), so Cancel can restore a removed row
        // and re-removing a row always works (no dependency on an immediate DB call).
        setState(prevState => ({
            ...prevState,
            territories: prevState.territories.filter((_, i) => i !== index),
        }));
    }
    const fetchListOnClick = (e, type) => {
        //This is used when u already have territory created but the list is not fetched on edit, only on product type change so we need to fetch markets and territories  on click of dropdown
        if (e.target.closest('.MuiAutocomplete-root')) {
            if(type == "markets"){
                if(territory.isExisting && marketOptionsCached.length == 0){
                    fetchMarketsByProductType(territory.PRODUCT_TYPE_ID, "read")
                }
            }

            if(type == "territories"){
                if(territory.isExisting && territoryOptionsCached.length == 0){
                    fetchTerritoresByMarket(territory.MARKET_ID, "read")
                }
            }
        }
    }

    return (
        <div key={`territory-${index}`}>
            <div className="Team-member-territory">
                <Dropdown
                    className="Team-member-info_column_item"
                    data={{}}
                    optionKey='CODE'
                    optionLabelKey='NAME'
                    options={productTypeOptions.length > 0 ? productTypeOptions : []}
                    value={productTypeOptions.find(el => el.ARCIMEDES_ROW_ID == territory.PRODUCT_TYPE_ID) ? productTypeOptions.find(el => el.ARCIMEDES_ROW_ID == territory.PRODUCT_TYPE_ID).CODE : ""}
                    valueKey="TYPE"
                    label="Product Type"
                    handleParentChange={(e) => onTerritoryChange(e, "PRODUCT_TYPE", index)}
                    viewMode={viewMode}
                    deleted={false}
                    dropdownType="single"
                    optionsType="productType"
                />
                {territory.PRODUCT_TYPE_ID && (!viewMode || territory.MARKET_ID) &&
                 <div className="collapse-inputs" onClick={(e) => fetchListOnClick(e, "markets")}>
                    <Dropdown
                        className="Team-member-info_column_item"
                        data={{}}
                        options={marketOptions.length > 0 ? marketOptions : []}
                        value={marketOptions.find(m => m.ARCIMEDES_ROW_ID ==  territory.MARKET_ID) ? marketOptions.find(m => m.ARCIMEDES_ROW_ID ==  territory.MARKET_ID).CODE : ""}
                        valueKey="MARKET"
                        label="Market"
                        handleParentChange={(e) => onTerritoryChange(e, "MARKET", index)}
                        viewMode={viewMode}
                        deleted={false}
                        dropdownType="single"
                        optionsType="territoryMarket"
                        optionLabelKey='NAME'
                        optionKey='CODE'
                    />
                </div>
                }
                {territory.MARKET_ID && (!viewMode || territory.TERRITORY_ID) &&
                    <div className="collapse-inputs" onClick={(e) => fetchListOnClick(e, "territories")}>
                        <Dropdown
                            className="Team-member-info_column_item"
                            data={{}}
                            options={territoryCityOptions}
                            value={territoryCityOptions.find(t => t.code == territory.TERRITORY_ID) ? territoryCityOptions.find(t => t.code == territory.TERRITORY_ID).code : ""}
                            valueKey="TERRITORY"
                            label="Territory"
                            handleParentChange={(e) => onTerritoryChange(e, "TERRITORY", index)}
                            viewMode={viewMode}
                            deleted={false}
                            dropdownType="single"
                            optionsType="territoryMarket"
                            optionLabelKey='name'
                            optionKey='code'
                        />
                    </div>
                }
                {(territory.PRODUCT_TYPE_ID && viewMode == "")&& <button type="button" className="Team-member-territory_button" onClick={deleteTerritory}>Remove</button>}
            </div>
        </div>
    );
};

export default TeamMemberTerritoriesInfo;
